import {getOrCreateDeviceId, getStoredSessionId, storeSessionId} from "./storage";
import {getDeviceInfo} from "./device";
import {getUTMParams} from "./utm";
import {getLocation} from "./geo";
import {SessionData, GeographicLocation} from "./type";

export async function initSession(siteId: string): Promise<SessionData> {
  const deviceId = getOrCreateDeviceId();
  const sessionId = getStoredSessionId() || Math.random().toString(36).substring(2, 15);
  const deviceInfo = getDeviceInfo();
  const utm = getUTMParams();
  // const browserLoc = await getBrowserGeolocation();
  const loc = await getLocation();

  const geographic_location: GeographicLocation | undefined = loc;

  if (!getStoredSessionId()) {
    storeSessionId(sessionId);
  }
  // console.log({
  //   session_id: sessionId,
  //   device_id: deviceId,
  //   site_id: siteId,
  //   source: document.referrer,
  //   utm_source: utm.utm_source,
  //   utm_campaign: utm.utm_campaign,
  //   utm_medium: utm.utm_medium,
  //   device_type: deviceInfo.device || "Unknown",
  //   browser_type: deviceInfo.browser || "Unknown",
  //   operating_system: deviceInfo.os || "Unknown",
  //   page_url: window.location.href,
  //   device_info: deviceInfo,
  //   geographic_location,
  // });
  return {
    session_id: sessionId,
    device_id: deviceId,
    site_id: siteId,
    source: document.referrer,
    utm_source: utm.utm_source,
    utm_campaign: utm.utm_campaign,
    utm_medium: utm.utm_medium,
    device_type: deviceInfo.device || "Unknown",
    browser_type: deviceInfo.browser || "Unknown",
    operating_system: deviceInfo.os || "Unknown",
    page_url: window.location.href,
    device_info: deviceInfo,
    geographic_location,
  };
}
